import HeatmapService from '@/services/HeatmapService'

export default {
  state: {
    // Heatmap configs
    heatmapConfigs: [],
    selectedHeatmapId: null,
    heatmapGrid: null,
    heatmapGridLoading: false
  },
  mutations: {
    setHeatmapConfigs (state, configs) {
      state.heatmapConfigs = configs
    },
    setSelectedHeatmapId (state, heatmapId) {
      state.selectedHeatmapId = heatmapId
    },
    setHeatmapGrid (state, grid) {
      state.heatmapGrid = grid
    },
    setHeatmapGridLoading (state, loading) {
      state.heatmapGridLoading = loading
    }
  },
  actions: {
    // === Heatmap configs actions ===
    fetchHeatmapConfigs ({ commit }) {
      return HeatmapService.getHeatmaps()
        .then(configs => {
          commit('setHeatmapConfigs', Array.isArray(configs) ? configs : [])
          return configs
        })
        .catch(err => {
          console.error('fetchHeatmapConfigs error', err)
          commit('setHeatmapConfigs', [])
        })
    },
    selectHeatmap ({ commit }, heatmapId) {
      commit('setSelectedHeatmapId', heatmapId)
      if (!heatmapId) {
        commit('setHeatmapGrid', null)
      }
    },
    executeSelectedHeatmap ({ commit, state }, date) {
      const heatmapId = state.selectedHeatmapId
      if (!heatmapId) return Promise.resolve()
      commit('setHeatmapGridLoading', true)
      return HeatmapService.executeHeatmap(heatmapId, date)
        .then(grid => {
          commit('setHeatmapGrid', grid)
          commit('setHeatmapGridLoading', false)
          return grid
        })
        .catch(err => {
          commit('setHeatmapGridLoading', false)
          console.error('Error executing heatmap', err)
        })
    },
    createHeatmapConfig ({ dispatch }, payload) {
      const { queries, ...heatmapPayload } = payload
      return HeatmapService.createHeatmap(heatmapPayload)
        .then(heatmap => {
          const queryPromises = (queries || []).map(query =>
            HeatmapService.addQueryToHeatmap(heatmap.id, query)
          )
          return Promise.all(queryPromises).then(() => {
            dispatch('fetchHeatmapConfigs')
            return heatmap
          })
        })
    },
    updateHeatmapConfig ({ dispatch }, { heatmapId, payload, originalQueries }) {
      const { queries, ...heatmapPayload } = payload
      return HeatmapService.updateHeatmap(heatmapId, heatmapPayload)
        .then(() => {
          const currentQueryIds = (queries || []).map(q => q.favorite_query_id)
          const originalQueryIds = (originalQueries || []).map(q => q.favorite_query_id)

          const toRemove = originalQueryIds.filter(queryId => !currentQueryIds.includes(queryId))

          // Upsert all current queries to update display_order
          const upsertPromises = (queries || []).map(query => HeatmapService.addQueryToHeatmap(heatmapId, query))
          const removePromises = toRemove.map(queryId => HeatmapService.removeQueryFromHeatmap(heatmapId, queryId))

          return Promise.all([...upsertPromises, ...removePromises]).then(() => {
            dispatch('fetchHeatmapConfigs')
          })
        })
    },
    deleteHeatmapConfig ({ dispatch }, heatmapId) {
      return HeatmapService.deleteHeatmap(heatmapId)
        .then(() => dispatch('fetchHeatmapConfigs'))
    },
    reorderHeatmapConfigs ({ dispatch }, orders) {
      return HeatmapService.reorderHeatmaps(orders)
        .then(() => dispatch('fetchHeatmapConfigs'))    },
    reorderHeatmapQueries ({ dispatch, state }, { heatmapId, orders }) {
      return HeatmapService.reorderHeatmapQueries(heatmapId, orders)
        .then(() => {
          if (state.selectedHeatmapId === heatmapId) {
            return dispatch('executeSelectedHeatmap')
          }
        })    }
  }
}
